import { has } from "lodash";
import { from, Observable } from "rxjs";
import { store } from "..";
import { API } from "../../services/http";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { processErrorFromPromise } from "../errors/utils";
import { LaunchesActions } from "./actions";
import { LaunchesDTO } from "./models/dto";

export namespace LaunchesService {
  const api = new API("kyc-upload");

  export function getLaunches(): Observable<
    FetchableError | FetchableSuccess<LaunchesDTO.Responses.GetAll.T>
  > {
    return from(
      api
        .get(`ui/configurations/landing-page`)
        .then<FetchableSuccess<LaunchesDTO.Responses.GetAll.T>>((response) => ({
          status: "ready",
          data: response.body,
        }))
        .catch<FetchableError>(processErrorFromPromise)
        .catch<FetchableError>((err) => ({
          status: "error",
          err,
        }))
    );
  }

  export function getSingle(
    id: LaunchesDTO.Responses.GetSingle.T["id"]
  ): Promise<LaunchesDTO.Responses.GetSingle.T> {
    const { configurations } = store.getState().launches;

    if (has(configurations, id) && configurations[id] !== "LOADING") {
      return Promise.resolve(
        configurations[id] as LaunchesDTO.Responses.GetSingle.T
      );
    }

    store.dispatch(LaunchesActions.getSingleLaunch(id));
    return api
      .get(`ui/configurations/${id}`)
      .then<LaunchesDTO.Responses.GetSingle.T>((response) => {
        store.dispatch(
          LaunchesActions.setSingleLaunch({
            id,
            result: response.body,
          })
        );
        return response.body;
      })
      .catch<LaunchesDTO.Responses.GetSingle.T>(processErrorFromPromise);
  }
}
